import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ListAlumniEvents from "./List";
import { EVENTS } from "utils/constants";

import permissions from "app/permissions";
import CreateAlumniEvent from "./Create";
import EditAlumniEvent from "./Edit";
import ShowAlumniEvent from "./Show";

//permissions
export const resources = {
  isMenu: true,
  icon: <ManageAccountsIcon />,
  name: EVENTS,
  title: "Алумни събития",
  list: <ListAlumniEvents />,
  create: <CreateAlumniEvent />,
  edit: <EditAlumniEvent />,
  show: <ShowAlumniEvent />,
  createPermission: permissions.canManageAlumniEvents,
  editPermission: permissions.canManageAlumniEvents,
  permission: permissions.canPreviewAlumniEvents,
  showPermission: permissions.canPreviewAlumniEvents,
};
